import styled from 'styled-components'
import { breakpoints } from '../../utils'
import { getTheme } from '@albatross/common-components/dist/themes'
import * as BallyUkTheme from '@albatross/common-components/dist/themes/ballyuk'
import { ballyFonts } from '../../components/fontStyles'

const authorDescription = `
 color: #000000;
 font-weight: 400;
 font-size: 12px;
 line-height: 18px;
 white-space: pre-line;

 @media (min-width: ${breakpoints[2]}px) {
  font-size: 14px;
 }
`

export const StyledApp = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;
  max-width: 1280px;
  margin: auto;

  /* Allows you to scroll below the viewport; default value is visible */
  section {
    margin: 0 auto;
  }
  @media (max-width: ${breakpoints[4]}px) {
    padding-top: ${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.mobilePaddingTop : styles.mobileNoNavPaddingTop)}px;
  }
  @media (min-width: ${breakpoints[4] + 1}px) {
    padding-top:  ${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.desktopPaddingTop : styles.desktopNoNavPaddingTop)}px;
  }
`

export const StyledAuthorImage = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  object-fit: contain;

  @media (min-width: ${breakpoints[2]}px) {
    height: 168px;
    width: 168px;
  }
`

export const StyledAuthorName = styled.span`
 ${ballyFonts}
 color: ${({ venture }) => getTheme(venture, 'colors.primary.main', {
  overrides: {
    ballyuk: '#200833',
    monopolycasino: '#ffffff'
  }
 })};
 font-weight: ${({ venture }) => venture === 'ballyuk' ? 800 : 700};
 font-size: 16px;
 font-family: ${({ venture }) => getTheme(venture, 'fonts.primary.name', {
  overrides: {
    ballyuk: BallyUkTheme.fonts.quinary.name
  }
 })};

 @media (min-width: ${breakpoints[2]}px) {
  font-size: 24px;
 }
`

export const StyledAuthorDescription = styled.p`
 ${authorDescription}
`

export const StyledContentfulAuthorDescription = styled.div`
  ${authorDescription}
  color: ${({ venture }) => (venture === 'monopolycasino' || venture === 'monopolycasino_es') ? '#A4B8E5' : '#000000'};
`

export const StyledContainer = styled.div`
 & p {
  margin: 0; 
 }

 display: flex;
 column-gap: 16px;
 
 ${({ authorDescription }) => (!authorDescription &&
    `flex-direction: column;
   align-items: center;
   font-size: 32px;
   @media (min-width: ${breakpoints[2]}px) {
    row-gap: 16px;
   }
  `
  )};

 @media screen and (min-width: ${breakpoints[0]}px) {
  padding: 16px 16px 24px 16px;
 }

 @media screen and (min-width: ${breakpoints[4]}px) {
  padding: 52px 0px 32px 0px;
 }
 
`

export const StyledNoBlogPost = styled.p`
 text-align: center;
 font-weight: 800;
 margin-bottom: 100px;
 margin-top: 100px;
 opacity: 0.6;
 font-size: 16px;

 @media (min-width: ${breakpoints[2]}px) {
  font-size: 24px;
  margin-bottom: 125px;
  margin-top: 125px;
 }
`
export const StyledHr = styled.hr`
  margin: 0px;
  opacity: 0.30;
`
